<div *ngIf="!hidePager" class="lv-action">
  <div class="lv-action-title">{{ 'COMMON.DOCUMENT_VIEWER.PAGER.TITLE' | translate }}</div>
  <div class="lv-container">
    <button mat-icon-button [disabled]="disabled || current === 0" (click)="currentChange.emit(current - 1)">
      <mat-icon svgIcon="long-arrow-up"></mat-icon>
    </button>
    <div class="lv-state-label">
      <span *ngIf="total">{{ current + 1 }} / {{ total }}</span>
    </div>
    <button mat-icon-button [disabled]="disabled || current + 1 === total" (click)="currentChange.emit(current + 1)">
      <mat-icon svgIcon="long-arrow-down"></mat-icon>
    </button>
  </div>
</div>

<div *ngIf="!hideZoom" class="lv-action">
  <div class="lv-action-title">Zoom: </div>
  <div class="lv-container">
    <button mat-icon-button [disabled]="disabled || zoomLevel === MIN_ZOOM_LEVEL" (click)="zoom(-ZOOM_FACTOR)">
      <mat-icon svgIcon="minus"></mat-icon>
    </button>
    <div class="lv-state-label">{{ zoomLevel }}</div>
    %
    <button mat-icon-button [disabled]="disabled || zoomLevel === MAX_ZOOM_LEVEL" (click)="zoom(ZOOM_FACTOR)">
      <mat-icon svgIcon="Plus"></mat-icon>
    </button>
  </div>
</div>

<div *ngIf="!hideRotation" class="lv-action">
  <div class="lv-action-title">{{ 'Drehen' }}</div>
  <div class="lv-container">
    <button mat-icon-button [disabled]="disabled" (click)="rotateCounterClockwise()">
      <mat-icon svgIcon="Undo"></mat-icon>
    </button>
    <button mat-icon-button [disabled]="disabled" (click)="rotateClockwise()">
      <mat-icon svgIcon="Redo"></mat-icon>
    </button>
  </div>
</div>

<div *ngIf="!hideCustomActions" class="lv-custom-actions">
  <div class="lv-action" *ngFor="let action of actions">
    <button mat-raised-button [disabled]="disabled" (click)="executeAction.emit(action)">
      <div class="lv-action-button-label">
        <mat-icon class="lv-action-icon-button" *ngIf="action.icon" [svgIcon]="action.icon"></mat-icon>
        Download
      </div>
    </button>
  </div>
</div>
